import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Row, Col, Form, Alert, Button } from 'react-bootstrap';
import { saveMultipleDaysAppointmentSlots } from "../../../services/medengage/Service";

const CNAddSlots = (props) => {
    const [startSlot, setStartSlot] = useState('');
    const [endSlot, setEndSlot] = useState('');
    const [action, setAction] = useState("");
    const [selectedDays, setSelectedDays] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [timeSlots, setTimeSlots] = useState([]);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    useEffect(() => {
        generateTimeSlots();
    }, []);

    const generateTimeSlots = () => {
        const slots = [];
        let start = 0; //12 am
        let end = (23 * 60) + 50; //11:50 pm

        while (start <= end) {
            const hours = Math.floor(start / 60);
            const minutes = start % 60;
            const formattedTime = `${('0' + (hours % 12 || 12)).slice(-2)}:${('0' + minutes).slice(-2)} ${hours < 12 ? 'AM' : 'PM'}`;
            slots.push(formattedTime);
            start += props.slotDuration;
        }
        setTimeSlots(slots);
    };

    const handleStartSlotChange = (e) => {
        const value = e.target.value;
        setStartSlot(value);

        if (endSlot && timeSlots.indexOf(endSlot) < timeSlots.indexOf(value)) {
            setEndSlot('');
            setError('End time should be after or equal to start time.');
        } else {
            setError('');
        }
    };

    const handleEndSlotChange = (e) => {
        const value = e.target.value;
        setEndSlot(value);

        if (startSlot && timeSlots.indexOf(value) < timeSlots.indexOf(startSlot)) {
            setEndSlot('');
            setError('End time should be after or equal to start time.');
        } else {
            setError('');
        }
    };

    const handleDayChange = (day) => {
        if (selectedDays.includes(day)) {
            const updatedDays = selectedDays.filter(d => d !== day);
            setSelectedDays(updatedDays);
            setAllChecked(false);
        } else {
            const updatedDays = [...selectedDays, day];
            setSelectedDays(updatedDays);
            if (updatedDays.length === daysOfWeek.length) {
                setAllChecked(true);
            }
        }
    };


    const handleToggleAll = () => {
        if (allChecked) {
            setSelectedDays([]);
        } else {
            setSelectedDays([...daysOfWeek]);
        }
        setAllChecked(!allChecked);
    };

    const handleWPSave = async () => {
        setError("");
        setMessage("");

        if (action === "") {
            setError("Select the action");
        } else if (startSlot === "") {
            setError("Select the start time");
        } else if (endSlot === "") {
            setError("Select the end time");
        } else if (selectedDays.length <= 0) {
            setError("Select at least 1 day of week");
        } else {
            const request = axios.CancelToken.source();
            let ct = { cancelToken: request.token };

            const startIndex = timeSlots.indexOf(startSlot);
            const endIndex = timeSlots.indexOf(endSlot);
            const newlySelectedSlots = timeSlots.slice(startIndex, endIndex + 1);

            let finalDaywiseSelectedSlots = {};
            let anyChangeMade = false;

            for (const day of selectedDays) {
                const existingSlots = props.origSelectedSlots[day] || [];
                let updatedSlots = [];

                if (action === "select") {
                    updatedSlots = [...existingSlots, ...newlySelectedSlots];
                } else if (action === "deselect") {
                    updatedSlots = existingSlots.filter(slot => !newlySelectedSlots.includes(slot));
                }

                updatedSlots = updatedSlots.map(slot => {
                    let lowerSlot = slot.toLowerCase();
                    if (lowerSlot.includes('am') || lowerSlot.includes('pm')) {
                        return lowerSlot.replace('am', 'AM').replace('pm', 'PM');
                    }
                    return slot;
                });

                const uniqueSortedSlots = Array.from(new Set(updatedSlots)).sort(
                    (a, b) => timeSlots.indexOf(a) - timeSlots.indexOf(b)
                );

                finalDaywiseSelectedSlots[day] = uniqueSortedSlots;

                const originalSet = new Set(existingSlots);
                const updatedSet = new Set(uniqueSortedSlots);

                if (action === "select") {
                    for (const slot of newlySelectedSlots) {
                        if (!originalSet.has(slot)) {
                            anyChangeMade = true;
                            break;
                        }
                    }
                } else if (action === "deselect") {
                    for (const slot of newlySelectedSlots) {
                        if (originalSet.has(slot)) {
                            anyChangeMade = true;
                            break;
                        }
                    }
                }
            }

            if (!anyChangeMade) {
                setError(action === "select"
                    ? "No new slot selected between the given time range."
                    : "No slot between selected time range.");
                return;
            }

            await saveMultipleDaysAppointmentSlots(props.cnId, selectedDays, finalDaywiseSelectedSlots, ct)
                .then((response) => {
                    if (response.data.code === 200) {
                        setSelectedDays([]);
                        setStartSlot('');
                        setEndSlot('');
                        props.getWorkingPlansAndBreaks(props.cnId);
                        setMessage(response.data.data.message);
                    } else {
                        setError(response.data.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });

            return () => request.cancel();

        }
    };



    const handleWPSaveOld = async () => {
        setError("");
        setMessage("");
        if (action === "") {
            setError("Select the action");
        } else if (startSlot === "") {
            setError("Select the start time");
        } else if (endSlot === "") {
            setError("Select the end time");
        } else if (selectedDays.length <= 0) {
            setError("Select at least 1 day of week");
        } else {
            const request = axios.CancelToken.source();
            let ct = { cancelToken: request.token };

            const startIndex = timeSlots.indexOf(startSlot);
            const endIndex = timeSlots.indexOf(endSlot);

            let newlySelectedSlots = timeSlots.slice(startIndex, endIndex + 1);

            let finalDaywiseSelectedSlots = {};

            for (const day in props.origSelectedSlots) {

                if (!selectedDays.includes(day)) continue;

                const existingSlots = props.origSelectedSlots[day] || [];

                let mergedSlots = [];

                if (selectedDays.includes(day)) {
                    mergedSlots = [...existingSlots, ...newlySelectedSlots];
                } /*else {
                    mergedSlots = [...existingSlots];
                }*/

                // Fix casing AM/PM
                mergedSlots = mergedSlots.map(slot => {
                    let lowerSlot = slot.toLowerCase();
                    if (lowerSlot.includes('am') || lowerSlot.includes('pm')) {
                        return lowerSlot
                            .replace('am', 'AM')
                            .replace('pm', 'PM');
                    }
                    return slot;
                });

                const uniqueSlots = Array.from(new Set(mergedSlots));

                uniqueSlots.sort((a, b) => {
                    const aIndex = timeSlots.indexOf(a);
                    const bIndex = timeSlots.indexOf(b);
                    return aIndex - bIndex;
                });

                finalDaywiseSelectedSlots[day] = uniqueSlots;
            }

            console.log(finalDaywiseSelectedSlots);


            await saveMultipleDaysAppointmentSlots(props.cnId, selectedDays, finalDaywiseSelectedSlots, ct)
                .then((response) => {
                    if (response.data.code === 200) {
                        setSelectedDays([]);
                        setStartSlot('');
                        setEndSlot('');
                        props.getWorkingPlansAndBreaks(props.cnId);
                        setMessage(response.data.data.message);
                    } else {
                        setError(response.data.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();

        }
    };


    return (
        <div className="container-fluid mt-3">
            <Row className="mb-2">
                <Col md={4} className="px-0">
                    <Form.Group controlId="startSlot">
                        <Form.Label>Action</Form.Label>
                        <Form.Select value={action} onChange={(e) => setAction(e.target.value)} className='form-select control-input-uibox'>
                            <option value="">Select Action</option>
                            <option value="select">Select Slots</option>
                            <option value="deselect">Deselect Slots</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={4} className="px-2">
                    <Form.Group controlId="startSlot">
                        <Form.Label>Start Time</Form.Label>
                        <Form.Select value={startSlot} onChange={handleStartSlotChange} className='form-select control-input-uibox'>
                            <option value="">Select Start Time</option>
                            {timeSlots.map((slot, index) => (
                                <option key={index} value={slot}>
                                    {slot}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={4} className="px-0">
                    <Form.Group controlId="endSlot">
                        <Form.Label>End Time</Form.Label>
                        <Form.Select value={endSlot} onChange={handleEndSlotChange} className='form-select control-input-uibox'>
                            <option value="">Select End Time</option>
                            {timeSlots.map((slot, index) => (
                                <option key={index} value={slot}>
                                    {slot}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>

                <div className="col-12 px-0 mt-2"><hr /></div>

            </Row>

            {error && (
                <Row className="mb-3">
                    <Col>
                        <Alert variant="danger">{error}</Alert>
                    </Col>
                </Row>
            )}

            {
                message && (
                    <Row className="mb-3">
                        <Col>
                            <Alert variant="success">{message}</Alert>
                        </Col>
                    </Row>
                )
            }



            <Row className="mb-2">
                <Col className='px-0'>
                    <Form.Check
                        type="checkbox"
                        label="Select/Deselect All"
                        checked={allChecked}
                        onChange={handleToggleAll}
                    />
                </Col>
            </Row>

            <Row>
                {daysOfWeek.map((day, index) => (
                    <Col key={index} className='px-0'>
                        <Form.Check
                            type="checkbox"
                            label={day}
                            checked={selectedDays.includes(day)}
                            onChange={() => handleDayChange(day)}
                        />
                    </Col>
                ))}

            </Row>


            <Row className="mt-4">
                <Col className='px-0'>
                    <Button variant="primary" className='copy-save-btn' onClick={handleWPSave}>Save</Button>
                    <p></p>
                </Col>
            </Row>
        </div>
    );
};

export default CNAddSlots